import { groupListOption } from '@/api/base/baseCargoSpec'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(groupListOption)
